export enum PageListType {
  mine = 'my_lists',
  offline = 'offline_lists',
  favorite = 'favorite_lists'
}

export enum LystTypeFilter {
  allLysts = 'all_lysts',
  offlineLysts = 'offline_lysts',
  publicLysts = 'public_lysts',
  privateLysts = 'private_lysts',
  likedLysts = 'liked_lysts',
  favoriteLysts = 'favorite_lysts',
}
